<template>
  <section
    :data-component-name="$options.name"
    :data-page="jel_getNomRouteCourante()"
    class="section-sansTheme section-page gs_section row no-gutters image-fond"
    :class="classObject"
    :style="[getStyleObject()]"
  >
    <div class="contenu mx-auto" :class="[content.cssClassContenu]">
      <Heading
        v-if="!hideTitleIfMobile(content.afficherTitreMobile)"
        :class="[
          content.titleCSS ? content.titleCSS : 'gs_titre graphik_bold mb-4',
          content.titleOverBackground === 'true' ? 'gs_titre_top_neg' : '',
        ]"
        :contentType="content.typeTitle || 'grandTitre'"
        :style="{ color: content.titleColor }"
        v-html="content.title"
      />
      <p v-if="content.title2" class="gs_sous_titre">
        {{ content.title2 }}
      </p>

      <EditableArea
        :content="content.grandeSection"
        :parentTemplateId="metadata['mgnl:template']"
      />
    </div>
  </section>
</template>

<script>
import { EditableArea } from '@/vue-editor';
// Components
import Heading from '@/components/base/Heading';

export default {
  name: 'GrandeSection',
  components: {
    EditableArea,
    Heading,
  },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      classObject: [
        this.jel_getClassObject(this.content),
        this.content.coinArrondi,
        this.content.marginTop && this.content.marginTop == 'false' ? 'mt-0 pt-0' : '',
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.jel_setCookieAffichage(this.content); // nextTick obligatoire
    });
  },
  methods: {
    hideTitleIfMobile(titreAfficherMobile) {
      return this.isSmallScreen() && titreAfficherMobile !== 'true';
    },

    isSmallScreen() {
      return !!(this.$mq == 'sm' || this.$mq == 'xs');
    },
    getStyleObject() {
      return {
        'background-color':
          this.content.fondCouleur?.field === 'couleurEdit'
            ? this.content.fondCouleur.secBgThemeColor
            : null,

        'background-image': this.getBackgroundImage(),
      };
    },
    getBackgroundImage() {
      // Image pour mobile
      if (this.isSmallScreen()) {
        if (this.content.imageMobile) {
          return `url(${this.jel_getFichierSrc(this.content.imageMobile)})`;
        }
        return null;
      }

      // image pour desktop
      if (this.content.image) {
        return `url(${this.jel_getFichierSrc(this.content.image)})`;
      }

      // aucune image
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.contenu {
  background-position: center;
  background-repeat: no-repeat;
  max-width: 1280px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.image-background-limite {
  max-width: 1280px;
  @media screen and (min-width: 768px) and (max-width: 1312px) {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
}
.contenu.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}

.gs_section {
  overflow: visible;
  padding-bottom: 1%;
  padding-top: 1%;
}
.gs_titre {
  text-align: left;
  @include ms-respond(font-size, 6);
  position: relative;
  line-height: 1.25;
  padding-left: 16px;
  padding-right: 16px;

  @include media-breakpoint-down(sm) {
    color: #808080 !important;
  }
}

.gs_sous_titre {
  text-align: left;
  @include ms-respond(font-size, 2);
  margin-top: -1.5rem;
  color: #000000;
  // margin-bottom: 55px;
  // margin-left: 15%;
}
.gs_titre_top_neg {
  top: -5rem !important;
  margin-bottom: -6rem !important;
}

// lié a content.typeCoin
.coin_haut {
  border-top-left-radius: ms(3);
  border-top-right-radius: ms(3);
}

.coin_bas {
  border-bottom-left-radius: ms(3);
  border-bottom-right-radius: ms(3);
}

.quatreCoin {
  border-radius: ms(3);
}

.margin_top_entre_section {
  margin-top: 5rem;
}

.margin_bottom_entre_section {
  margin-bottom: 5rem;
}

@media screen and (max-width: 765px) {
  .gs_titre {
    text-align: center;
    margin-left: 0;
    font-size: 42px;
  }

  .gs_titre_top_neg {
    top: -3.5rem !important;
    margin-bottom: 0rem;
  }

  .gs_sous_titre {
    margin-left: 0;
    text-align: center;
  }
}

.image-fond {
  @media screen and (min-width: 768px) {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center top;
  }
}

.main-bingo .section-page {
  overflow: visible;
}

@include media-breakpoint-down(sm) {
  ::v-deep .tableau-bingo table {
    border-top: 10px solid #ffdd00;
    border-bottom: 10px solid #ffdd00;
  }
}

/* Ajout CSS pour page Acueil */
.titre-accueil {
  clear: both;
  padding: 2% 0;
  position: relative;
  text-align: center;
  margin: auto;
  font-family: $font-graphik-semibold;
  font-size: 4.6666666667vw;
  padding-bottom: 0.8rem;
  margin-bottom: 1.5rem;
  color: $couleur-blanc;
  @include media-breakpoint-up(md) {
    font-size: 1.4rem;
    padding-bottom: 0.5rem;
  }
  @include media-breakpoint-up(lg) {
    font-size: 1.5rem;
  }
}

.titre-accueil::after {
  position: absolute;
  content: '';
  bottom: 0;
  height: 0.1rem;
  width: 64px;
  left: calc(50% - 32px);
  background-color: $couleur-blanc;
  @include media-breakpoint-up(md) {
    left: calc(50% - 32px);
    height: 0.1rem;
    width: 64px;
  }
}

/* Fin ajout CSS pour page Acueil */
</style>
